import type { Device } from "types/device.types"
import type { PowerlinePositionViewVariant } from "types/devicePosition.types"

import sentriV4S3 from "images/devices/position/dynamic/sentri-v4-s3.png"
import sentriV4S1 from "images/devices/position/dynamic/sentri-v4-s1.png"
import sentriV2V3S1 from "images/devices/position/dynamic/sentri-v2-v3-s1.png"
import sentriV2V3S2 from "images/devices/position/dynamic/sentri-v2-v3-s2.png"
import { getDeviceVersionAndTarget, isVersionAboveOrEqual } from "./devices"

const TOOLTIP_KEY_PREFIX = "plots_descriptions.DEVICE_POSITION"

export const getPowerlinePositionViewVariant = (
  device: Device,
): PowerlinePositionViewVariant => {
  const { version, target } = getDeviceVersionAndTarget(device)
  return isVersionAboveOrEqual(version, target) ? "powerline-v4" : "powerline-legacy"
}

export const getPowerlineViewsSrcs = (variant: PowerlinePositionViewVariant) => {
  switch (variant) {
    case "powerline-v4":
      return { firstViewSrc: sentriV4S3, secondViewSrc: sentriV4S1 }
    case "powerline-legacy":
    default:
      return { firstViewSrc: sentriV2V3S1, secondViewSrc: sentriV2V3S2 }
  }
}

export const getPowerlinePlotTooltipContent = (): string[] => [
  `${TOOLTIP_KEY_PREFIX}.LAST_POSITION_POWERLINE`,
]
